<template>
    <div class="">
        <div class="page-wrapper">
            <div class="page-header-title">
                <div class="page-header-title-label">添加学习人员</div>
            </div>
            <div class="page-header-brief">
                说明：勾选公司/部门后，其下所有成员将被添加至此学习计划中，如需单独选择人员，请在左侧选择部公司/部门后，在右侧成员中单独勾选
            </div>

            <div class="page-content-wrapper">
                <div class="page-item-wrapper">
                    <div class="page-content-title-wrapper">
                        <div class="page-content-title">
                            <div style="height: 25px;line-height: 20px;text-align: center;"> 公司/部门</div>
                        </div>
                    </div>
                    <div class="transfer-counter">
                        已选{{ totalCheckedNum }}人/共{{ totalMemberNum }}人
                    </div>
                    <div class="transfer-container">
                        <div class="transfer-header">
                            <div class="transfer-all-check">
                                <el-checkbox v-model="allUnSelectChecked" @change="handleUnselectAll">全选</el-checkbox>
                            </div>

                        </div>
                        <div class="transfer-content-container">
                            <div class="transfer-content-wrapper">
                                <div class="transfer-content">
                                    <el-tree ref="treeDay" node-key="deptId" :data="tableData" :props="defaultTree"
                                        :check-on-click-node="true" :highlight-current="true" default-expand-all
                                        @node-click="handleTree">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <span>{{ node.label }}</span>
                                            <span>（已选{{ data.selectedMemberCount }}人/共{{ data.memberCount }}人）</span>
                                        </span>
                                    </el-tree>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-item-wrapper">
                    <div class="page-item-wrapper">
                        <div class="page-content-title-wrapper">
                            <div class="page-content-title">
                                <div style="height: 25px;line-height: 20px;text-align: center;">成员</div>
                                <div style="position: relative;">
                                    <div style="width: 480px;position: absolute;right: -30px;"> <el-input v-model="userNmae"
                                            clearable style="width: 370px;" placeholder="请输入内容"></el-input> <el-button
                                            type="primary" @click="search">搜索</el-button></div>

                                </div>
                            </div>
                        </div>
                        <div class="transfer-counter">
                            已选{{ checkedNum }}人/共{{ memberNum }}人
                        </div>
                        <div class="transfer-container">
                            <div class="transfer-header">
                                <div class="transfer-all-check">
                                    <el-checkbox v-model="selectedAllChecked" @change="handleSelectedAll">全选</el-checkbox>
                                </div>

                            </div>
                            <div class="transfer-content-container">
                                <div class="transfer-content-wrapper">
                                    <div v-if="selectedData.length > 0" class="transfer-content">
                                        <div v-for="(item, index) in selectedData" :key="'member-' + index"
                                            class="transfer-item"
                                            :style="index == selectedData.length - 1 ? 'border:0;' : ''">
                                            <el-checkbox v-model="item.checked" @change="justifySelected">
                                                <div class="selected-row-wrapper">
                                                    <div class="selected-row-name">{{ item.name }}</div>
                                                    <div class="selected-row-line"></div>
                                                    <div class="selected-row-phone">{{ item.mobile }}</div>

                                                </div>
                                            </el-checkbox>
                                            <div class="selected-row-position">{{ item.position }}</div>
                                        </div>
                                    </div>
                                    <div v-else class="transfer-content">
                                        <div class="selected-row-phone" style="text-align:center;">
                                            暂无成员
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-bottom-wrapper">
                <div class="page-bottom-label">
                    提示：完成后，可再次编辑，进行添加成员
                </div>
                <div class="page-btn-wrapper">
                    <div class="page-btn deal-btn btn-gap" @click="handleLast">上一步</div>
                    <div class="page-btn deal-btn btn-gap" @click="handleDeal">完成</div>
                    <div class="page-btn cancel-btn btn-gap" @click="handleBack">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    planMemberOrgList,
    planMemberTotalList,
    planMemberList,
    planMemberChecked,
    createPlanMember
} from '@/api/index.js';
export default {
    name: '',
    components: {

    },
    data() {
        return {
            userNmae: "",
            dept: '',
            token: '',
            allUnSelectChecked: false,
            defaultTree: {
                children: 'children',
                label: 'deptName'
            },
            tableData: [],
            totalMemberNum: 0,
            totalCheckedNum: 0,
            memberNum: 0,
            checkedNum: 0,
            selectedAllChecked: false,
            selectedData: [],
            activeDept: '',
            activeDeptItem: {},
            memberChecked: [],
            memberSelected: []
        }
    },
    mounted() {
        scrollTo(0, 0);
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.getTableData();
    },
    methods: {
        //搜索
        search() {
            this.getMemberList(this.userNmae)
        },
        getTableData() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            planMemberOrgList(planInfo.id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var treeData = res.data.deptList;
                    this.tableData = treeData;
                    this.totalCheckedNum = res.data.selectedMemberCount;
                    this.totalMemberNum = res.data.memberCount;
                    this.memberSelected = res.data.selectedUserIdList || []
                    if (treeData.length > 0) {
                        var defaultTree = '';
                        if (this.activeDept == '') {
                            defaultTree = this.recursionDeptId(treeData, this.dept);
                            if (!defaultTree) {
                                defaultTree = treeData[0]
                            }
                            this.$nextTick(function () {
                                this.$refs.treeDay.setCurrentKey(defaultTree.deptId);
                            });
                        } else {
                            defaultTree = this.activeDept;
                            this.$nextTick(function () {
                                this.$refs.treeDay.setCurrentKey(defaultTree.deptId);
                            });
                        }
                        this.handleTree(defaultTree);
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleTree(row) {
            this.userNmae = ''
            if (this.activeDept != row.deptId && row.enableViewMember) {
                this.selectedAllChecked = false
                this.activeDept = row.deptId;
                this.activeDeptItem = row
                // this.memberSelected=[];
                this.getMemberList();
            } else if (this.activeDept != row.deptId) {
                this.selectedAllChecked = false
                let activeDeptItem = this.recursionDept(row.children)
                if (activeDeptItem) {
                    this.activeDept = activeDeptItem.deptId;
                    this.activeDeptItem = activeDeptItem
                    this.getMemberList();
                }
            }
        },
        // 递归获取第一个enableViewMember 为true
        recursionDept(arrData) {
            let activeDeptItem = null
            if (arrData && arrData.length !== 0) {
                for (const item of arrData) {
                    if (item.enableViewMember) {
                        activeDeptItem = item;
                        break;
                    } else {
                        this.recursionDept(item.children)
                    }
                }
            }
            return activeDeptItem
        },
        getMemberList(keyword) {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            planMemberList(planInfo.id, {
                "deptId": this.activeDept,
                "keyword": keyword,
                "pageNum": 1,
                "pageSize": 10000,
                "userDeptId": 0,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    let selectedData = res.data.list
                    this.checkedNum = 0
                    if (selectedData && selectedData.length !== 0) {
                        selectedData.forEach(item => {
                            // 如果已选设置成已选
                            if (this.memberSelected.includes(item.userId)) {
                                this.$set(item, 'checked', true)
                                this.checkedNum++
                            }
                        });
                    }
                    this.selectedData = selectedData;
                    if (this.checkedNum !== 0 && res.data.list && res.data.list.length !== 0 && this.checkedNum === res.data.list.length) {
                        this.selectedAllChecked = true
                    }
                    // this.memberNum=res.data.totalRecords;
                    this.getMemberCheckedList();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getTotalMemberList() {
            planMemberTotalList({
                "deptId": this.activeDept,
                "keyword": "",
                "pageNum": 1,
                "pageSize": 10000,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.selectedData = res.data.list;
                    this.memberNum = res.data.totalRecords;
                    this.getMemberCheckedList();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });

        },
        getMemberCheckedList() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            var depId = this.activeDept;
            planMemberChecked(planInfo.id, depId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.memberChecked = res.data;
                    let memberSelected = [];
                    if (res.data.length !== 0) {
                        res.data.forEach((item) => {
                            if (!this.memberSelected.includes(item)) {
                                memberSelected.push(item)
                            }
                        })
                    }
                    this.memberSelected = [...this.memberSelected, ...memberSelected]
                    // this.checkedNum=res.data.length;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleUnselectAll() {
            var allUnSelectChecked = this.allUnSelectChecked;
            var tableData = this.tableData;
            var deptIdArr = [];
            if (allUnSelectChecked) {
                for (var i = 0; i < tableData.length; i++) {
                    this.tableData[i]['checked'] = true;
                    deptIdArr.push(tableData[i]["deptId"]);
                    if (i == tableData.length - 1) {
                        this.$refs.treeDay.setCurrentKey(deptIdArr);
                    }
                }
                this.getTotalMemberList();
            } else {
                for (var i = 0; i < tableData.length; i++) {
                    this.tableData[i]['checked'] = false;
                    if (i == tableData.length - 1) {
                        this.$refs.treeDay.setCurrentKey([]);
                    }
                }
                this.getMemberList();
            }
        },
        justifyUnselect() {
            var tableData = this.tableData;
            if (tableData.length == 0) {
                this.allUnSelectChecked = false;
            } else {
                var num = 0;
                for (var i = 0; i < tableData.length; i++) {
                    var item = tableData[i];
                    if (item.checked) {
                        num++;
                    }
                    if (i == tableData.length - 1) {
                        if (num == tableData.length) {
                            this.allUnSelectChecked = true;
                        } else {
                            this.allUnSelectChecked = false;
                        }
                    }
                }
            }
        },
        handleSelectedAll() {
            var selectedAllChecked = this.selectedAllChecked;
            var tableData = this.selectedData;
            if (selectedAllChecked) {
                for (var i = 0; i < tableData.length; i++) {
                    this.selectedData[i]['checked'] = true;
                }
            } else {
                for (var i = 0; i < tableData.length; i++) {
                    this.selectedData[i]['checked'] = false;
                }
            }
            this.addMemberToList();
        },
        justifySelected(val) {
            var selectedData = this.selectedData;
            if (selectedData.length == 0) {
                this.selectedAllChecked = false;
            } else {
                var num = 0;
                for (var i = 0; i < selectedData.length; i++) {
                    var item = selectedData[i];
                    if (item.checked) {
                        num++;
                    }
                    if (i == selectedData.length - 1) {
                        if (num == selectedData.length) {
                            this.selectedAllChecked = true;
                        } else {
                            this.selectedAllChecked = false;
                        }
                        this.addMemberToList();
                    }
                }
            }
        },
        addMemberToList() {
            var data = this.selectedData;
            var newArr = [];
            let checkedNum = this.checkedNum;
            if (data && data.length !== 0) {
                checkedNum = data.filter((item) => item.checked).length
            }
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                if (item.checked && !this.memberSelected.includes(item.userId)) { // 如果勾选判断已选数组添加并去重数据
                    newArr.push(item.userId);
                } else if (!item.checked && this.memberSelected.includes(item.userId)) { // 如果取消勾选已选数组去除数据
                    let memberIndex = this.memberSelected.findIndex((memberItme) => memberItme === item.userId)
                    if (memberIndex > -1) {
                        this.$delete(this.memberSelected, memberIndex)
                    }
                }
                if (i == data.length - 1) {
                    this.memberSelected = [...this.memberSelected, ...newArr];
                    this.checkedNum = checkedNum;
                    this.totalCheckedNum = this.memberSelected.length
                    // 左侧已选数量赋值
                    if (this.tableData && this.tableData.length !== 0 && this.activeDeptItem) {
                        this.$set(this.activeDeptItem, 'selectedMemberCount', checkedNum)
                    }
                }
            }
        },
        handleLast() {
            this.$emit('step', 'add-measure');
        },
        handleDeal() {
            var userList = this.memberSelected;
            if (userList.length > 0) {
                var planInfo = JSON.parse(window.localStorage.getItem('plan'));
                var deptId = '';
                if (!this.allUnSelectChecked) {
                    deptId = this.activeDept;
                }
                createPlanMember({
                    "deptId": deptId,
                    "planId": planInfo.id,
                    "userId": 0,
                    "userIdList": userList
                }, {
                    Authorization: this.token,
                    DeptId: this.dept
                }).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.totalCheckedNum += userList.length;
                        var treeData = this.tableData;
                        this.updateTree(deptId, userList, treeData);
                        this.handleBack()
                    }
                    return;
                }).catch(err => {
                    // console.log(err);
                });
            } else {
                this.$message.error('请选择成员');
            }
        },
        handleBack() {
            this.$router.go(-1);
            //   this.$router.push(`/studyPlan/manage-plan`);
        },
        updateTree(deptId, userList, data) {
            var activeRow;
            var isHas = false;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                if (item.deptId == deptId) {
                    isHas = true;
                    activeRow = item;
                    return false;
                }
                if (i == data.length - 1 && activeRow) {
                    if (isHas == false) {
                        this.updateTree(deptId, userList, activeRow.children);
                    }
                }
            }
        },
        // 递归获取用户默认的组织数据
        recursionDeptId(arrData, id = null) {
            if (!arrData || arrData.length === 0) {
                return null
            }
            if (arrData && arrData.length !== 0) {
                for (const item of arrData) {
                    if (item.deptId === Number(id) && item.enableViewMember) {
                        return item;
                    } else {
                        let result = this.recursionDeptId(item.children, id)
                        if (result) {
                            return result;
                        }
                    }
                }
            }
        },
    }
}
</script>

<style scoped>
.page-container {
    display: flex;
}

.page-wrapper {
    flex: 1;
    margin-top: 40px;
}

.page-header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-header-title-label {
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

.page-header-brief {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-top: 30px;
}

.page-content-wrapper {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;
    padding-bottom: 29px;
    border-bottom: 1px solid #F0F0F0;
}

.page-content-title-wrapper {
    display: flex;
    justify-content: space-around;
}

.page-item-wrapper {
    width: 454px;
}

.page-content-title {
    width: 100%;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    height: 80px;

}

.transfer-container {
    width: 100%;
    height: 682px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #CBCBCB;
    margin-top: 16px;
}

.transfer-header {
    width: 100%;
    height: 52px;
    background: #F7F7F8;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.transfer-all-check {
    margin-left: 20px;
}

.transfer-header>>>.el-checkbox__label {
    font-size: 16px !important;
}

.transfer-content-container {
    width: 100%;
}

.transfer-content-search-wrapper {
    width: 420px;
    margin: 0 auto;
}

.transfer-content-wrapper {
    width: 100%;
    height: 610px;
    padding-top: 19px;
    overflow-x: hidden;
    overflow-y: auto;
}

.scrollbar {
    width: 30px;
    height: 300px;
    margin: 0 auto;
}

.transfer-content-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 1px;
}

.transfer-content-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgb(193, 193, 193);
    background: #535353;
}

.transfer-content-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: #ededed;
}

.transfer-content {
    width: 420px;
    margin: 0 auto;
}

.transfer-item {
    padding-top: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #EAEAEA;
}

.transfer-item-checkbox-wrapper {
    display: flex;
}

.transfer-checkbox {
    position: relative;
    top: 3px;
    margin-right: 10px;
}

.transfer-checkbox-label {
    width: 100%;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #333333;
    cursor: pointer;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

.transfer-btn {
    height: 682px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0px 20px 0px 20px;
}

.transfer-btn-item {
    width: 122px;
    height: 40px;
    background: #3E63EE;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.transfer-btn-item:hover {
    cursor: pointer;
    opacity: 0.8;
}

.transfer-btn-bottom {
    margin-top: 40px;
}

.transfer-item-record-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.transfer-item-record-wrapper {
    display: flex;
    margin-left: 24px;
    margin-top: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    align-items: center;
}

.transfer-record-line {
    width: 1px;
    height: 16px;
    margin-left: 8px;
    margin-right: 8px;
    background: #D7D7D7;
}

.page-btn-wrapper {
    display: flex;
}

.page-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.deal-btn {
    background: #3E63EE;
    color: #FFFFFF;
}

.deal-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.cancel-btn {
    border: 1px solid #4F79ED;
    color: #4F79ED;
}

.cancel-btn:hover {
    cursor: pointer;
    background: #4F79ED;
    color: #fff
}

.btn-gap {
    margin-left: 20px;
}

.selected-header-wrapper {
    display: flex;
    align-items: center;
}

.selected-header-img {
    width: 22px;
    height: 22px;
}

.selected-header-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    position: relative;
    top: -2px;
    margin-left: 5px;
}

.transfer-counter {
    margin-right: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}

.page-bottom-wrapper {
    display: flex;
    justify-content: space-around;
    margin-top: 50px;
    padding-bottom: 50px;
    align-items: center;
}

.transfer-content>>>.el-tree-node__expand-icon {
    font-size: 22px !important;
    color: #3E63EE !important;
}

.transfer-content>>>.el-tree-node__content {
    height: 38px !important;
}

.transfer-content>>>.el-tree-node__label {
    font-size: 20px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #333333 !important;
}

.selected-row-wrapper {
    display: flex;
}

.selected-row-position {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-left: 120px;
    text-align: right;
}

.selected-row-name {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.selected-row-phone {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
}

.selected-row-line {
    width: 1px;
    height: 14px;
    margin-right: 18px;
    margin-left: 18px;
    background: #D7D7D7;
    position: relative;
    top: 3px;
}
</style>


